import React, { useState } from 'react';

import { Telemetry } from '@videoblocks/kafka-rest-client';

import WhitelistRequestAPI from '../WhitelistRequestAPI';
import YoutubeChannelValidationRequestAPI from '../YoutubeChannelValidationRequestAPI';
import SuccessfulSubmission from '../components/SuccessfulSubmission';
import WhitelistRequestForm from '../components/WhitelistRequestForm';

const WhitelistRequestFormContainer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [youTubeChannelValidationError, setYouTubeChannelValidationError] =
    useState('');

  const allFieldsExist = ({
    audioTrackId,
    audioTrackUrl,
    claimant,
    otherClaimant,
    youtubeChannelId,
    youtubeVideoUrl,
  }) => {
    const validClaimant =
      claimant?.length > 0 ||
      (claimant === 'Other' && otherClaimant?.length > 0);

    const validAudioTrack =
      audioTrackId?.length > 0 || audioTrackUrl?.length > 0;

    return (
      validClaimant &&
      validAudioTrack &&
      youtubeChannelId?.length > 0 &&
      youtubeVideoUrl?.length > 0
    );
  };

  const submitClaimDispute = async (request) => {
    if (youTubeChannelValidationError?.length > 0) {
      setErrorMessage('Please enter a valid YouTube Channel ID');
    } else if (!allFieldsExist(request)) {
      setErrorMessage('All fields are required');
    } else {
      setIsLoading(true);

      try {
        await WhitelistRequestAPI.submitWhitelistRequest(
          request.claimant,
          request.youtubeVideoUrl,
          request.youtubeChannelId,
          request.audioTrackUrl,
          request.audioTrackId,
          request.otherClaimant
        );

        setShowSuccessMessage(true);
        setErrorMessage(null);
      } catch (err) {
        setErrorMessage(err.message);
        setShowSuccessMessage(false);
      }

      setIsLoading(false);
    }
  };

  const validateYouTubeChannel = async (youtubeChannelId) => {
    const validateYoutubeChannelTimer = Telemetry.timer(
      'youtubeService.frontEnd.validateChannel'
    );

    try {
      const response = await YoutubeChannelValidationRequestAPI.validateChannel(
        { youtubeChannelId }
      );
      const validationResponse = await response.json();

      setYouTubeChannelValidationError(validationResponse.errorMessage);
    } catch (err) {
      setYouTubeChannelValidationError(
        'We are unable to validate your YouTube channel at this time'
      );
    } finally {
      validateYoutubeChannelTimer;
    }
  };

  return (
    <>
      {showSuccessMessage && <SuccessfulSubmission />}

      {!showSuccessMessage && !showForm && (
        <button
          className="whitelistRequestForm-startClaim btn btn-primary"
          onClick={() => setShowForm(true)}
        >
          Start a new dispute
        </button>
      )}

      {!showSuccessMessage && showForm && (
        <>
          <button
            disabled={isLoading}
            className="whitelistRequestForm-closeForm btn mt-6 mb-8"
            onClick={() => setShowForm(false)}
          >
            Cancel
          </button>

          <hr className="whitelistRequestForm-divider" />

          <WhitelistRequestForm
            errorMessage={errorMessage}
            isLoading={isLoading}
            submitClaimDispute={submitClaimDispute}
            validateYouTubeChannel={validateYouTubeChannel}
            youTubeChannelValidationError={youTubeChannelValidationError}
          />
        </>
      )}
    </>
  );
};

export default WhitelistRequestFormContainer;
